import React, { FC } from 'react';
import { ReactComponent as NotificationBell } from '../../../assets/Header/NotificationBell.svg';

export const NotificationBellIcon: FC = () => <NotificationBell />;
